import script from "./officeplus.vue?vue&type=script&setup=true&lang=ts"
export * from "./officeplus.vue?vue&type=script&setup=true&lang=ts"

import "./officeplus.vue?vue&type=style&index=0&id=0b896afe&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b896afe"]])

export default __exports__